import ReadMore from '@monofront/design-system/components/ReadMore';
import { useTranslations } from 'next-intl';
import references from '@monofront/design-system/css-library/tokens/reference';

interface IDescriptionProps {
  description?: string;
  dataTestId?: string;
  enableSeeMore?: boolean;
  UNSAFE_className?: string;
}

export const Description: React.FC<IDescriptionProps> = ({
  description,
  dataTestId = '',
  enableSeeMore = false,
  UNSAFE_className = '',
}) => {
  const tGlobal = useTranslations('Global');

  if (!description) {
    return null;
  }

  const DescriptionFormatted = () => (
    <div
      data-testid={dataTestId}
      className={`
      ${UNSAFE_className}
      [&_a]:tw-lf-body-bold-md
      [&_h3]:tw-lf-body-bold-md
      [&_ul]:tw-lf-bullet-list
      [&_ul_li]:tw-lf-bullet-list-item
      [&>*]:tw-mb-4
      [&_a]:tw-cursor-pointer
      [&_a]:tw-leading-snug
      [&_a]:tw-underline
      [&_a]:tw-transition-all
      [&_a]:tw-duration-[0.3s]
      [&_a]:tw-ease-[ease]
      [&_h2]:tw-mt-8
      [&_h3]:tw-mt-1
      hover:[&_li_a]:tw-opacity-60
      focus:[&_li_a]:tw-opacity-60
      [&_p]:tw-leading-[150%]
      [&_ul]:tw-leading-[150%]
      [&_ul_li:not(:last-child)]:tw-mb-2
      [&_ul_li]:before:tw-top-2
    `}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );

  if (!enableSeeMore) {
    return <DescriptionFormatted />;
  }

  return (
    <div className="[&_button]:tw-mx-4 desktop:[&_button]:tw-mx-0">
      <ReadMore
        backgroundColor={references.colors.beige[200]}
        clampLimit={4}
        isCondensed
        seeMoreText={tGlobal('seeMore')}
        seeLessText={tGlobal('seeLess')}
      >
        <DescriptionFormatted />
      </ReadMore>
    </div>
  );
};
